import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=515d0c22&scoped=true&"
import script from "./submitDialog.vue?vue&type=script&lang=js&"
export * from "./submitDialog.vue?vue&type=script&lang=js&"
import style0 from "./submitDialog.vue?vue&type=style&index=0&id=515d0c22&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d0c22",
  null
  
)

export default component.exports